import { call, put, select } from 'redux-saga/effects';
import { LoadType } from 'store/sagas/apiService/types';
import { queryData } from 'store/sagas/apiService';
import { navigateTo } from 'store/state/router/actions';
import { IAgentPageData, RealEstateLevel } from 'utils/entities';
import { Route, State as RouteState } from 'config/routes';
import { parseSoldDealBannerPath } from 'utils/parse-sold-deal-banner-filename';
import { agentByIdSelector } from 'store/state/domainData/selectors/common';

export function* agentSharePageHandler(route: RouteState) {
  const { id, banner } = route.params;

  if (!banner) {
    yield put(navigateTo(Route.Home, {}, { replace: true }));
    return;
  }

  const parsedResult = parseSoldDealBannerPath(banner);

  if (parsedResult && parsedResult.agentId !== id) {
    yield put(navigateTo(Route.Home, {}, { replace: true }));
    return;
  }

  yield call(queryData, { loadType: LoadType.AgentById, meta: { variables: { id, level: RealEstateLevel.Public } } });
  const agentData: IAgentPageData = yield select(agentByIdSelector);

  if (!agentData) {
    yield put(navigateTo(Route.Home, {}, { replace: true }));
    return;
  }
}
